import { render, staticRenderFns } from "./ProjectImpactLinksTab.vue?vue&type=template&id=2ab3183f&scoped=true&"
import script from "./ProjectImpactLinksTab.vue?vue&type=script&lang=js&"
export * from "./ProjectImpactLinksTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3183f",
  null
  
)

export default component.exports